<template>
    <v-container fluid pa-0 style="user-select: none;">
        <v-row>
            <v-col cols="6">
                <draggable
                        @choose="setChosenOption($event)"
                        @unchoose="handleUnchoose($event)"
                        @start="dragging = true"
                        @end="setOption($event)"
                        handle=".rank-option-handle"
                        :group="{ name: 'rank-options', pull: false }"
                        :sort="false"
                >
                    <v-card v-for="(option, optionIndex) of options" :key="optionIndex"
                            :id="'rank_option_' + option.optionid"
                            style="display: flex; align-items: center;" class="mb-3 white"
                    >
<!--                        (chosenOption != null && chosenOption == option.optionid) ||-->
                        <div class="rank-option-used"
                             v-if="selectedOptions.indexOf(option.optionid) > -1"></div>
<!--                        :style="{opacity: chosenOption == null || chosenOption != option.optionid ? 1 : 0}"-->
                        <v-row no-gutters>
                            <v-col cols="1" class="rank-option-character-container">
                                {{chars[optionIndex]}}
                            </v-col>
                            <v-col cols="11" style="display: flex; align-items: center;">
                                <v-card-text class="black--text">
                                    {{$ta(option.content_textassetid)}}
                                </v-card-text>
                                <v-icon class="rank-option-handle pr-3" style="color: grey; cursor: grab;">
                                    mdi-drag-vertical
                                </v-icon>
                            </v-col>
                        </v-row>
                    </v-card>
                </draggable>
            </v-col>
            <v-col cols="1" style="display: flex; justify-content: center;">
                <v-divider vertical class="white"></v-divider>
            </v-col>
            <v-col cols="5">
                <v-card v-for="(field, fieldIndex) of fields" :key="fieldIndex" :id="'rank_field_' + field.fieldid"
                        style="display: flex; align-items: center;" class="mb-3 white"
                        @dragover.prevent
                        @dragover="highlightField($event, field)"
                        @dragleave="clearHighlightedField($event, true)"
                >
                    <v-row no-gutters>
                        <v-col cols="6" style="background-color: #1E496C;">
                            <v-card-text>
                                {{$ta(field.content_textassetid)}}
                            </v-card-text>
                        </v-col>
                        <v-col v-if="answers" cols="6"
                               style="transition: background-color .8s ease;"
                               :class="{'rank-field-drop-area': answers[field.fieldid] == null, 'rank-field-drop-area--highlighted': dragging && answers[field.fieldid] == null, 'rank-field-character-container': answers[field.fieldid] != null, 'rank-field-highlighted': answers[field.fieldid] == null && highlightedField != null && highlightedField == field.fieldid}">
                            <small v-if="answers[field.fieldid] == null">
                                {{$t('general.drop_answer_here')}}
                            </small>
                            <template v-else>
                                 <span>
                                    {{chars[options.findIndex(option => option.optionid == answers[field.fieldid])]}}
                                </span>
                                <v-btn icon style="position: absolute;"
                                       :style="removeBtnStyle"
                                       @click="clearAnswer(field.fieldid)">
                                    <v-icon color="black">
                                        mdi-minus-circle-outline
                                    </v-icon>
                                </v-btn>
                            </template>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import Draggable from 'vuedraggable';

    export default {
        components: {
            Draggable
        },
        props: {
            options: {
                type: Array,
                required: true
            },
            fields: {
                type: Array,
                required: true
            },
            value: {
                type: Object,
                required: true
            }
        },
        data: () => ({
            answers: null,
            chars: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'],
            leaderLineOptions: {
                startSocket: 'right',
                endSocket: 'left',
                color: '#BA9529',
                //color: '#205377',
                endPlug: 'behind',
                hide: true,
                size: 2
            },
            dragging: false,
            chosenOption: null,
            highlightedField: null,
            leaderLines: {},
            removeBtnStyle: {right: 0}
        }),
        computed: {
            selectedOptions() {
                return this.answers ? Object.values(this.answers) : [];
            }
        },
        watch: {
            value() {
                this.cloneValue();
            }
        },
        methods: {
            cloneValue() {
                this.answers = JSON.parse(JSON.stringify(this.value || {}));
                setTimeout(() => {
                    this.drawLines();
                }, 800);
            },
            emitInput() {
                this.$emit('input', this.answers);
                this.drawLines();
            },
            drawLines() {
                let optionNode,
                    fieldNode,
                    optionId;
                Object.keys(this.answers).forEach((fieldId) => {
                    if (!this.leaderLines[fieldId]) {
                        optionId = this.answers[fieldId];
                        if (optionId != null) {
                            optionNode = document.getElementById('rank_option_' + this.answers[fieldId]);
                            fieldNode = document.getElementById('rank_field_' + fieldId);
                            if (!!optionNode && !!fieldNode) {
                                this.leaderLines[fieldId] = new window.LeaderLine(optionNode, fieldNode, this.leaderLineOptions);
                                this.leaderLines[fieldId].show('draw');
                            }
                        }
                    }
                });
            },
            removeLine(fieldId, hideFirst = true) {
                hideFirst && this.leaderLines[fieldId].hide('draw');
                setTimeout(() => {
                    this.leaderLines[fieldId].remove();
                    this.$set(this.leaderLines, fieldId, null);
                }, hideFirst ? 600 : 0);
            },
            setOption() {
                this.dragging = false;
                if (this.highlightedField && this.chosenOption != null && !this.answers[this.highlightedField] && !this.selectedOptions.includes(this.chosenOption)) {
                    this.$set(this.answers, this.highlightedField, this.chosenOption);
                    this.emitInput();
                }
                this.clearChosenOption();
                this.clearHighlightedField();
            },
            clearAnswer(fieldId) {
                this.$set(this.answers, fieldId, null);
                this.removeLine(fieldId);
                this.emitInput();
            },
            setChosenOption(event) {
                setTimeout(() => {
                    this.chosenOption = this.options[event.oldIndex].optionid;
                }, 200);
            },
            clearChosenOption() {
                this.chosenOption = null;
            },
            highlightField(event, field) {
                if (this.dragging && (!this.highlightedField || this.highlightedField != field.fieldid)) {
                    this.highlightedField = field.fieldid;
                }
            },
            clearHighlightedField() {
                this.highlightedField = null;
            },
            translateChars() {
                this.chars.forEach((char, index) => {
                    this.chars[index] = this.$t('alphabet.' + char);
                });
            },
            handleRtl() {
                if(this.$vuetify.rtl) {
                    this.removeBtnStyle = {left: 0};
                    this.leaderLineOptions.startSocket = 'left';
                    this.leaderLineOptions.endSocket = 'right';
                }
            },
            repositionLines() {
                Object.keys(this.leaderLines).forEach((fieldId) => {
                    this.leaderLines[fieldId].position();
                });
            },
            handleUnchoose() {
                if(!this.dragging) {
                    this.clearChosenOption();
                }
            }
        },
        mounted() {
            this.cloneValue();
            this.translateChars();
            this.handleRtl();
        },
        created() {
            window.addEventListener('scroll', this.repositionLines, true);
        },
        beforeDestroy() {
            Object.keys(this.leaderLines).forEach((fieldId) => {
                this.removeLine(fieldId, false);
                window.removeEventListener('scroll', this.repositionLines, true);
            });
        },
    };
</script>

<style>
    .rank-option-character-container {
        background-color: #E0E0E0;
        display: flex;
        align-items: center;
        justify-content: center;
        text-transform: uppercase;
        color: black;
        font-weight: bold;
        box-shadow: 1px 0 5px -1px #888;
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
    }

    .rank-field-character-container {
        display: flex;
        align-items: center;
        justify-content: center;
        text-transform: uppercase;
        color: black;
        font-weight: bold;
    }

    .rank-field-drop-area {
        display: flex;
        align-items: center;
        justify-content: center;
        font-style: italic;
        font-weight: normal;
        color: grey;
    }

    .rank-field-drop-area--highlighted {
        background: #E0E0E0;
    }

    .rank-option-used {
        background-color: #1E496C !important;
        border-color: #1E496C !important;
        opacity: 0.8;
        width: 100%;
        height: 100%;
        border-radius: 3px;
        position: absolute;
    }

    .rank-option-chosen {
        opacity: 0;
    }

    .rank-field-highlighted {
        background-color: rgba(30, 73, 108, 0.6);
        border: 1px solid white;
        color: white;
    }
</style>